import {module} from 'modujs';
import * as focusTrap from 'focus-trap';

export default class extends module {
    constructor(m) {
        super(m);

        this.events = {
            click: {
                close: 'hide'
            }
        }

        this.inner = this.$('inner')[0]
    }

    init() {
        this.focusTrap = focusTrap.createFocusTrap(this.el,{
            onDeactivate: this.hide.bind(this),
            clickOutsideDeactivates: true
        });
    }

    toggle(e) {
        if(this.el.classList.contains('is-active')) {
            this.hide()
        } else {
            this.show(e)
        }
    }

    show(e) {
        if(this.emptyTimeout) clearTimeout(this.emptyTimeout);

        this.appendDelay = setTimeout(() => {
            switch(e.platform) {
                case 'youtube':
                    this.videoUrl = `https://www.youtube-nocookie.com/embed/${e.id}?&autoplay=1`
                    this.inner.innerHTML = `<iframe src="https://www.youtube-nocookie.com/embed/${e.id}?&autoplay=1" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>`;
                    break;
                case 'vimeo':
                    this.videoUrl = `https://player.vimeo.com/video/${e.id}?autoplay=1&loop=1&autopause=0`
                    this.inner.innerHTML = `<iframe src="https://player.vimeo.com/video/${e.id}?autoplay=1&loop=1&autopause=0&title=0&byline=0&portrait=0" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>`
                    break;
                default:
                    break;
            }

            requestAnimationFrame(() => {
                this.focusTrap?.activate();
            })
        }, 500);

        this.el.classList.add('is-active');
    }

    hide() {
        clearTimeout(this.appendDelay)

        this.el.classList.remove('is-active');
        this.focusTrap?.deactivate();

        this.emptyTimeout = setTimeout(() => {
            this.inner.innerHTML = '';
        }, 250);
    }

    destroy() {
        super.destroy()
    }
}
